import styled from "styled-components";

export const VoucherGamesListBox = styled.div`
    display: flex;
    flex-direction: column;
    overflow-x: hidden;
    overflow-y: auto;
    height: 100%;
    width: 100%;
    align-items: center;
    margin: 0.5rem 0rem 2rem;
`